import {Checkbox as MuiCheckbox, FormControl, FormControlLabel, FormControlLabelProps, FormHelperText, styled} from "@mui/material";


const StyledMuiCheckbox = styled(MuiCheckbox)(({theme}) => ({
    "&:has(input[readonly])": {
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.background.default,
        cursor: "default",
    }
}));

export interface CheckboxProps {
    label: string;
    labelPlacement?: FormControlLabelProps['labelPlacement'];
    checked?: boolean;
    onChange?: (value: boolean) => void;

    required?: boolean;
    errorMessage?: string;
    readOnly?: boolean;
    disabled?: boolean;
}

export default function Checkbox(props: Readonly<CheckboxProps>) {
    const {label, checked, onChange, required, errorMessage, readOnly, disabled, labelPlacement} = props;
    return (
        <FormControl error={errorMessage !== undefined}>
            <FormControlLabel label={label}
                    labelPlacement={labelPlacement}
                    control={
                        <StyledMuiCheckbox checked={checked}
                                required={required}
                                readOnly={readOnly}
                                disabled={disabled}
                                onChange={(event, value) => onChange?.(value)} />
                    }/>
            {errorMessage &&
                <FormHelperText>{errorMessage}</FormHelperText>
            }
        </FormControl>
    );
}
